/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React, { ReactElement, useState } from "react";
import { I18n } from "i18n-js";
import * as locales from "../../../locales.json";
const i18n = new I18n(locales);
i18n.defaultLocale = "en";
i18n.locale = (window as any).locale || "";
import axios from "axios";
import styled from "styled-components";

import setUpAxios from "../../../helperFunctions/helperFunctions";

declare let Components: any;

interface ApprovalRequestFormProps {
    awardID: string;
    giverID: string;
    awardInvalid: boolean;
    claimableByUser: boolean;
}

const StyledTextArea = styled.textarea`
  width: 100%;
  height: 100px;
  margin-top: 15px;
`;

const StyledLabel = styled.label`
  width: 100%;
  display: inline-block;
  padding-bottom: 10px;
`;

const ApprovalRequestForm = ({
    awardID,
    giverID,
    awardInvalid,
    claimableByUser,
}: ApprovalRequestFormProps): ReactElement => {
    const [formData, setFormData] = useState({
        claim_reason: "",
    });
    const [error, setError] = useState(null);
    const [submitting, setSubmitting] = useState(false);

    const updateFormData = (event): void => {
        return setFormData({
            ...formData,
            [event.target.name]: event.target.value,
        });
    };

    const { claim_reason } = formData;

    const onSubmit = async (event): Promise<void> => {
        event.preventDefault();
        setUpAxios();
        setSubmitting(true);

        try {
            await axios.post("/awards/approval_requests", {
                approval_request: {
                    claim_reason,
                    award_id: awardID,
                    giver_id: giverID,
                },
            });
        } catch (err) {
            setError(err);
        }
        setSubmitting(false);
        window.location.reload();
    };

    return (
        <form onSubmit={onSubmit}>
            <div className="award-claim-reason">
                {/* this isn't playing nicely with styled components but we're not violating the rule */}
                {/* eslint-disable-next-line jsx-a11y/label-has-for */}
                <StyledLabel htmlFor="award-reason-input">
                    {i18n.translate("awards.claimable_awards.explain_reason")}
                    <StyledTextArea
                        value={claim_reason}
                        onChange={(e): void => {
                            return updateFormData(e);
                        }}
                        name="claim_reason"
                        id="award-reason-input"
                        required
                    />
                </StyledLabel>
            </div>

            <div className="modal-cta-btns">
                <button
                    type="button"
                    className="btn modal-cancel-btn"
                    data-dismiss="modal"
                >
                    {i18n.translate("forms.cancel")}
                </button>
                {awardInvalid ? (
                    <button
                        type="button"
                        onClick={(): void => {
                            Components.Growler.get("notifications").send(
                                "error",
                                i18n.translate("bonuses.give.bad_level_claimable")
                            );
                        }}
                        className="btn btn-primary modal-submit-btn invalid"
                    >
                        {i18n.translate("awards.claimable_awards.button_cta")}
                    </button>
                ) : (
                    <button
                        type="submit"
                        disabled={submitting || !claimableByUser}
                        className="btn btn-primary modal-submit-btn"
                    >
                        {i18n.translate("awards.claimable_awards.button_cta")}
                    </button>
                )}
            </div>
        </form>
    );
};

export default ApprovalRequestForm;
